const maxDescriptorLength = 22;

const sanitizeBusinessName = (businessName: string) =>
  businessName
    .toUpperCase()
    .replace(/[^A-Z0-9\s.,\-+&]/g, "")
    .trim();

const truncate = (value: string) =>
  value.length > maxDescriptorLength
    ? value.substring(0, maxDescriptorLength)
    : value;

/** Payout descriptor: `CPOS* BUSINESS_NAME` (max 22 chars). */
export const formatStatementDescriptor = (businessName: string) =>
  truncate(`CPOS* ${sanitizeBusinessName(businessName)}`);

/** Payment descriptor: `BUSINESS_NAME` (max 22 chars, no `*` allowed). */
export const formatPaymentStatementDescriptor = (businessName: string) =>
  truncate(sanitizeBusinessName(businessName));
